import { formValueSelector } from 'redux-form';
import { BAGGAGE_VALUES } from '../../common/utils/baggageUtils';
import { isPrimaryFlow } from '../../../common/utils/primaryFlow';
const isValidTraveler = traveler => {
  var _String;
  return typeof traveler === 'object' && (traveler.value === true || ((_String = String(traveler.value)) === null || _String === void 0 ? void 0 : _String.includes(BAGGAGE_VALUES.TRUE)) || traveler.value === BAGGAGE_VALUES.COMBINED) && traveler.included !== true;
};
const isNotSelectedValidTraveler = traveler => {
  return typeof traveler === 'object' && (traveler.value === false || traveler.value === BAGGAGE_VALUES.FALSE) && traveler.included !== true;
};
const payload = _ref => {
  let {
    id,
    weight,
    weightUnit
  } = _ref;
  return {
    travelerId: id,
    ...(weight && {
      weight
    }),
    ...(weightUnit && {
      weightUnit
    })
  };
};
export const getGraphQlSelection = (productId, formSection) => {
  return _ref2 => {
    var _selectedTravelers;
    let {
      form,
      state
    } = _ref2;
    const formData = formValueSelector(form)(state, formSection) || {};
    let selectedTravelers;
    if (!isPrimaryFlow()) {
      var _formData$value;
      selectedTravelers = formData === null || formData === void 0 || (_formData$value = formData.value) === null || _formData$value === void 0 || (_formData$value = _formData$value.filter(_ref3 => {
        let {
          exclude
        } = _ref3;
        return !exclude;
      })) === null || _formData$value === void 0 ? void 0 : _formData$value.map(_ref4 => {
        let {
          value,
          weight,
          weightUnit
        } = _ref4;
        return payload({
          id: value,
          weight,
          weightUnit
        });
      });
    } else {
      selectedTravelers = Object.values(formData).filter(isValidTraveler).map(value => payload({
        id: String(value === null || value === void 0 ? void 0 : value.id),
        weight: value === null || value === void 0 ? void 0 : value.weight,
        weightUnit: value === null || value === void 0 ? void 0 : value.weightUnit
      }));
    }
    return (_selectedTravelers = selectedTravelers) !== null && _selectedTravelers !== void 0 && _selectedTravelers.length ? {
      productId,
      selectionTravelerNumberOfUnits: selectedTravelers
    } : null;
  };
};
export const getDBFGraphQlSelection = (productId, formSection) => {
  return _ref5 => {
    let {
      form,
      state
    } = _ref5;
    const formData = formValueSelector(form)(state, formSection) || {};
    const selectedTravelers = Object.values(formData).filter(isValidTraveler).map(_ref6 => {
      let {
        id
      } = _ref6;
      return {
        travelerId: String(id),
        numberOfUnits: 1
      };
    });
    const notSelectedTravelers = Object.values(formData).filter(isNotSelectedValidTraveler).map(_ref7 => {
      let {
        id
      } = _ref7;
      return {
        travelerId: String(id),
        numberOfUnits: 0
      };
    });
    return {
      productId,
      selectionTravelerNumberOfUnits: selectedTravelers.concat(notSelectedTravelers)
    };
  };
};
//# sourceMappingURL=getGraphQlSelection.js.map